import objectFitImages from 'object-fit-images';

export default class ObjectFitImages {
    constructor(target) {
        this.target = target;
    }
    init() {
        objectFitImages(this.target);
    }
}